"use strict";

var _objectDestructuringEmpty = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectDestructuringEmpty");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var global_selectors_1 = require("../../redux/global/global.selectors");

var global_actions_1 = __importDefault(require("../../redux/global/global.actions"));

var top_navigation_component_1 = __importDefault(require("./top-navigation.component"));

var TopNavigationContainer = function TopNavigationContainer(_ref) {
  _objectDestructuringEmpty(_ref);

  var dispatch = react_redux_1.useDispatch();
  var appMode = react_redux_1.useSelector(global_selectors_1.selectAppMode);
  return react_1.default.createElement(top_navigation_component_1.default, {
    appMode: appMode,
    setAppMode: function setAppMode(appMode) {
      dispatch(global_actions_1.default.setAppMode(appMode));
    }
  });
};

exports.default = TopNavigationContainer;